import { memo } from "react";
import TableWidthContext from "../../contexts/TableWidthContext";

import styles from "./style.module.scss";

const NoData = memo(
  () => (
    <div className={styles.root}>
      <TableWidthContext.Consumer>
        {width => <div style={{ width }} className={styles.row}>No records found</div>}
      </TableWidthContext.Consumer>
    </div>
  ),
);

export default NoData;
